<template>
  <element>
    <AppBar :title="$t('barcodePage.title')" />
    <v-container>
      <h3 class="category-label">{{ $t('barcodePage.subtitle') }}</h3>
      <v-card class="p-2">
        <StreamBarcodeReader  @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader >
      </v-card>
      <h3 class="category-label text-center">{{ $t('barcodePage.scannedCode') }} {{ resultString }}</h3>
      <p class="subheading text-danger">{{ error }}</p>
        <v-btn color="#033e8c" dark block>{{ $t('barcodePage.button') }}</v-btn>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import { StreamBarcodeReader  } from 'vue-barcode-reader';

export default {
  name: "QRCodePage",
  components: {
    AppBar,
    StreamBarcodeReader ,
  },
  data () {
    return {
      error: "",
      resultString: ""
    }
  },
  props: {

  },
  methods: {
    onDecode (decodedString) {
      this.resultString = decodedString
    },

    async onLoaded (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "Error! You need to grant camera access permission"
        } else if (error.name === 'NotFoundError') {
          this.error = "Error! No camera found!"
        } else if (error.name === 'NotSupportedError') {
          this.error = "Error! Secure context required! (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "Error! The camera may be in use by other app"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "Error! Installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "Error! Stream API is not supported in this browser"
        }
      }
    }
  }
}
</script>

<style scoped>

</style>